var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2,
    fill: "#000",
    stroke: "c4c4c4",
    strokeLinejoin: "round",
    d: "M15.7 1.887a.62.62 0 00-.684-.028L2.328 9.08a.609.609 0 00-.328.6c0 .247.164.466.383.575l4.21 1.75v3.09c0 .246.11.465.329.601.11.028.219.055.3.055.11 0 .247-.027.356-.082l3.035-1.969 2.68 1.149c.082.027.164.054.273.054.11 0 .22-.054.301-.109.192-.082.301-.273.328-.465l1.75-11.812c.082-.246-.027-.493-.246-.63zM12.09 5.03l-5.113 5.715-2.844-1.203 7.957-4.512zm-4.211 8.86v-1.34l1.258.547-1.258.793zm5.168-.602l-4.813-2.023 6.125-6.809-1.312 8.832z"
  })));
}
export default SvgPreviewShare;